import React from "react";
import NavPublicUser from "../navbarPublicUser"
import PubCartBody from "../pubCartBody";
import Footer from "../Footer";
export default function PubCart(){

return(
<div>
<NavPublicUser />
<PubCartBody />
    <Footer />
</div>

)

}